/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Graph } from '../../models/graph';

export interface GetNodes$Params {
  periodId: string;
}

export function getNodes(http: HttpClient, rootUrl: string, params: GetNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Graph>> {
  const rb = new RequestBuilder(rootUrl, getNodes.PATH, 'get');
  if (params) {
    rb.path('periodId', params.periodId, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Graph>;
    })
  );
}

getNodes.PATH = '/v0/explore-graph/periods/{periodId}';
